import FlashbarMessageBroker from '../common/FlashbarMessageBroker';

/**
 * @deprecated Do not use the `@flashbar` decorator in new code.
 * It swallows errors into a global banner, hides the call site, and is
 * hard to test. See `FlashbarMessageBroker` for why the flashbar itself
 * is discouraged and what to reach for instead.
 */
function flashbar(options: {
  success?: string | ((...args: any[]) => string | undefined);
  error?:
    | string
    | Array<{ status: number; message: string }>
    | ((e: any) => { status: number; message: string; throwError?: boolean; timeout?: number });
}) {
  return (target: any, key: string, descriptor: TypedPropertyDescriptor<any>) => {
    const originalMethod = descriptor.value;
    let throwError = true;

    // @ts-expect-error TS7019 - strict migration
    descriptor.value = async function (...args) {
      const flashbarMessageBroker = FlashbarMessageBroker.create();
      try {
        const result = await originalMethod.apply(this, args);
        const successMessage =
          typeof options.success === 'function' ? options.success(...args) : options.success;
        if (successMessage) {
          flashbarMessageBroker.pushSuccessMessage(successMessage);
        }
        return result;
      } catch (error) {
        if (options.error) {
          if (typeof options.error === 'function') {
            const errorFunction = options.error(error);
            if (errorFunction) {
              const { status, message, timeout } = errorFunction;
              throwError = errorFunction.throwError ?? true;
              sendErrorMessageByStatus(flashbarMessageBroker, status, message, timeout);
            }
          } else if (Array.isArray(options.error)) {
            // @ts-expect-error TS2339 - strict migration
            let e = options.error.find((o) => o.status === error?.response?.status);
            if (!e) {
              e = { status: 500, message: 'Internal Server' };
            }
            sendErrorMessageByStatus(flashbarMessageBroker, e.status, e.message);
          } else {
            flashbarMessageBroker.pushErrorMessage(options.error);
          }
        }
        if (throwError) {
          throw error;
        }
      }
    };
    return descriptor;
  };

  function sendErrorMessageByStatus(
    flashbarMessageBroker: FlashbarMessageBroker,
    statusCode: number,
    message: string,
    timeout?: number,
  ) {
    if (statusCode < 300) {
      flashbarMessageBroker.pushSuccessMessage(message, timeout);
    } else if (statusCode < 400) {
      flashbarMessageBroker.pushInfoMessage(message, timeout);
    } else if (statusCode < 500) {
      flashbarMessageBroker.pushWarnMessage(message, timeout);
    } else {
      flashbarMessageBroker.pushErrorMessage(message, timeout);
    }
  }
}

export { flashbar };
